<template>

  <Toolbar />
  <Search />
  <Tabs />


</template>

<script>
  import Toolbar from './components/Toolbar.vue'
  import Search from './components/Search.vue'
  import Tabs from './components/Tabs.vue'
  import Footer from './components/Footer.vue'

  import { useQuasar } from 'quasar'

  export default {
    name: 'LayoutDefault',

    components: {
      Toolbar,
      Search,
      Tabs,
      Footer

    }
  }
</script>
<style>
  body {
    overflow-y: hidden;
  }
</style>